export default function sortByDate(data, fieldName) {
  let sortedArray = data;
  sortedArray.sort(
    (a, b) =>
      new Date(...a[fieldName].split("/").reverse()) -
      new Date(...b[fieldName].split("/").reverse())
  );
  return sortedArray;
}
